import React from "react";
import Analytic from "./analytic";
import SettingsMenuContainer from "pages/settings-page/menu/settings-menu-container";
import PeriodCalendarContainer from "items/period-calendar/period-calendar-container";
import FiltersContainer from "items/filters/filters-container";
import MyFiltersContainer from "items/myFilters/my-filters-container";
import TopicMenuContainer from "pages/topic-menu/topic-menu-container";
import { getFormatedDate } from "service/format-date";
import SearchTextContainer from "items/search-text/search-text-container";

class AnalyticController extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            selected: props.selected,
            selectedLanguage: this.props.selectedLanguage,
            selectedTopics: this.props.selectedTopics && this.props.selectedTopics.length ? this.props.selectedTopics.join(",") : "",
            selectedSubtopics: this.props.selectedSubtopics,
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            grouping: this.props.grouping,
            topics: this.props.topics,
            firstStart: false,
            firstChart: this.props.first.chartId,
            firstTopicIDs: this.props.first.topicIDs,
            firstLabels: this.props.first.labels.join(","),
            firstFields: this.props.first.fields ? Object.values(this.props.first.fields).join(',') : '',
            firstTotal: this.props.first.total,
            firstMax: 20,
            secondChart: this.props.second.chartId,
            secondTopicIDs: this.props.second.topicIDs,
            secondLabels: this.props.second.labels.join(","),
            secondFields: this.props.second.fields ? Object.values(this.props.second.fields).join(',') : '',
            secondTotal: this.props.second.total,
            secondMax: 20,
            thirdChart: this.props.third.chartId,
            thirdTopicIDs: this.props.third.topicIDs,
            thirdLabels: this.props.third.labels.join(","),
            thirdTotal: this.props.third.total,
            metric: null,
            metricTotal: 0,
            locationsName: this.props.locationsName ? Object.values(this.props.locationsName) : '', //Object.values(nextProps.locationsDictionary).join(",")
            deviceType: this.props.deviceType,
            topicsFiltersAuthors: this.props.topicFilters ? this.props.topicFilters.authors : 0,
            topicsFiltersDomains: this.props.topicFilters ? this.props.topicFilters.domains : 0,
            selectedLanguage: this.props.selectedLanguage
        }
        this.metrics = null;
    }

    getFormatedDate = (date) => {
        return getFormatedDate(date);
    }

    getFiltersList = (startDate, endDate, topics, fields, subtopics, filters) => {
        this.props.getFiltersStatistics(this.getFormatedDate(startDate), this.getFormatedDate(endDate), topics, fields, filters, subtopics);  
    }

    getData = (menuId, selectedUUid, startDate, endDate, grouping, filters, selectedSubUUId, isFetchingAnalytic, maxSize = null) => {
        if(!isFetchingAnalytic){
            this.props.getDataByType(this.props.menuItems[menuId].title, selectedUUid, this.getFormatedDate(startDate), this.getFormatedDate(endDate), grouping, filters, selectedSubUUId, this.props.tags, maxSize ? maxSize : {first: this.state.firstMax, second: this.state.secondMax});
        }
    }

    showRightMenu = (topics) => {
        if(this.props.deviceType !== 'mobile') this.props.setShowRightMenu(true);
        this.props.setRightMenuComponent(<PeriodCalendarContainer footerButtons={'grouping'}/>, 'periodCalendar', true);
        this.props.setRightMenuComponent(<MyFiltersContainer />, 'myFilters', true)
        this.props.setRightMenuComponent(<SearchTextContainer />, 'searchText');
       if(topics && topics.length){
            this.props.setPageName('Analytic')
            this.props.setRightMenuComponent(<FiltersContainer type={'Analytic'} topics={[topics]} getFiltersList={this.getFiltersList}/>, 'filters')
       }
    }



    showLeftMenu = (topics) => {
        if(this.props.deviceType !== 'mobile') this.props.setShowLeftMenu(true);
        if(topics && topics.length){
            this.props.setLeftMenuComponent(
                <TopicMenuContainer 
                    items={topics}
                    selected={this.props.selectedTopics}
                    showSubtopics={true}
                    type={'tree'}
                />, 'topics', true)
        }
    }

    showInfrastructure = () => {
        this.props.setMenus(this.props.menu);
        this.showRightMenu(this.props.topics && this.props.topics.length ? this.props.topics[0] : null)
        
        this.showLeftMenu(this.props.topics);
        this.props.setShowPanel(true)
    }

    setMaxData = (chart, max) => {
        let maxSize = {first: this.state.firstMax, second: this.state.secondMax}
        maxSize[chart] = max
        switch(chart){
            case 'first':
                this.setState({
                    firstMax: max
                })
                break;
            case 'second':
                this.setState({
                    secondMax: max
                })
        }
        let filters = this.props.selectedMyFilter;
        filters.clauses = this.props.searchList
        this.getData(this.props.selected, this.props.selectedTopics, this.props.startDate, this.props.endDate, this.props.grouping, filters, this.props.selectedSubtopics, false, maxSize)
    }

    componentDidMount(){
        /*if(this.props.startDate && this.props.endDate){
            this.props.setGroupingByPeriod(this.props.startDate, this.props.endDate);
           // this.props.setGr
        }*/
        if(this.props.selectedTopics && this.props.selectedTopics.length && this.props.selectedTopics.length > 1){
            this.props.setSelectedTopicsAll([this.props.selectedItems[0]])
        }
        this.showInfrastructure();
        this.props.getMyTopics();
        this.setState({
            firstStart: true
        })
    }

    getItemFromFilters = (filters, item) => {
        let f = filters.findIndex(k => k.name == item)
        return filters[f] && filters[f].items ? filters[f].items.length : 0
    }

    getMetrics = (data) => {
        let pageType = data.first.pageType;
        let metric = {mepageType: pageType, labels: [], data: [], total: 0};
        switch(pageType){
            case 'MENTIONS':
                if(data.second){
                    metric.title = "METRIC_BY_LANGUAGE_OF_MENTION";
                    metric.labels = data.second.labels;
                    metric.data = data.second.data; 
                    metric.total = data.second.total;
                    metric.colors = data.second.colors;
                    metric.position = 'second';
                    metric.fields = data.second.fields ? data.second.fields.language : [];
                    return metric;
                }
            case 'SOCIAL_NETWORKS':
                if(data.second){
                    metric.title = "METRIC_BY_SOCIAL_NETWORKS";
                    metric.labels = data.second.labels;
                    metric.data = data.second.data; 
                    metric.total = data.second.total;
                    metric.colors = data.second.colors;
                    metric.position = 'second';
                    metric.fields = data.second.fields ? data.second.fields.domain : [];
                    return metric;
                }
            case 'TONE':
                if(data.third){
                    metric.title = "METRIC_BY_SENTIMENT";
                    metric.labels = data.third.labels;
                    metric.data = data.third.data; 
                    metric.total = data.third.total;
                    metric.colors = data.third.colors;
                    metric.position = 'second';
                    metric.fields = data.third.fields ? data.third.fields.sentiment : [];
                    return metric;
                }
            case 'TYPES_OF_POSTS':
                if(data.second){
                    metric.title = "METRIC_BY_TYPE_OF_POSTS";
                    metric.labels = data.second.data ? data.second.data.map(k => k.name) : [];
                    metric.data = data.second.data ? data.second.data.map(k => k.data && k.data.length ? k.data.reduce((a,b) => {return a+b}) : []) : []; 
                    metric.total = data.second.total;
                    metric.colors = data.second.colors;
                    metric.position = 'second';
                    metric.fields = data.second.data ? data.second.data.map(k => k.name) : [];
                    return metric;
                }
            case 'AUTHORS':
                if(data.topicFilters){
                    metric.labelText = "NUMBER_OF_UNIQUE_AUTHORS";
                    let authors = data.topicFilters.authors;
                    metric.annotation = {title: data.first.labels ? data.first.labels[0] : null, text: "LEADER_AMONG_AUTHORS"};
                    metric.labels = data.first.data ? data.first.data.map((k,i) => k.name) : [];
                    metric.data = data.first.data ? data.first.data.map((k,i) => k.data[0]) : [];
                    metric.total = authors;
                    metric.chartTotal = (metric.data && metric.data.length) ? metric.data.reduce((a,b) => {return a+b}) : [];
                    metric.colors = data.first.colors;
                    metric.position = 'second';
                    metric.fields = data.first.fields ? data.first.fields.sentiment : [];
                    return metric;
                }
            case 'TOP_20_MASS_MEDIA':
                if(data.topicFilters){
                    metric.labelText = "NUMBER_OF_UNIQUE_SOURCES";
                    let sources = data.topicFilters.domains;
                    metric.annotation = {title: data.first.labels ? data.first.labels[0] : null, text: "LEADER_AMONG_SOURCES"};
                    metric.labels = data.first.data ? data.first.data.map((k,i) => k.name) : [];
                    metric.data = data.first.data ? data.first.data.map((k,i) => k.data[0]) : [];
                    metric.total = sources;
                    metric.chartTotal = (metric.data && metric.data.length) ? metric.data.reduce((a,b) => {return a+b}) : [];
                    metric.colors = data.first.colors;
                    metric.position = 'second';
                    metric.fields = data.first.fields ? data.first.fields.sentiment : [];
                    return metric;
                }
                case 'SOURCE_TYPE':
                    if(data.first){
                        metric.labels = data.first.labels;
                        if(data.first && data.first.data && data.first.data.length){
                            data.first.data.forEach((sentiment, i) => {
                                sentiment.data.forEach((mediaType, j) => {
                                    if(!metric.data[j])
                                        metric.data[j] = 0;
                                    metric.data[j] += mediaType
                                })
                            });
                        }
                        metric.total = data.first.total;
                        metric.colors = data.first.colors.filter((k,i) => i > 3);
                        metric.position = 'first';
                        metric.fields = data.first.fields ? data.first.fields.mediaType : [];
                        return metric;
                    }
                case 'REACH_OF_SOURCE':
                    
                    if(data.second){
                        metric.labelText = "NUMBER_OF_REACTIONS";
                        metric.labels = data.second.labels;
                        if(data.second.data){
                            metric.data = data.second.data;
                        }
                        metric.total = data.second.total;
                        metric.colors = data.second.colors;
                        metric.position = 'second';
                        metric.fields = data.second.labels;
                        return metric;
                    }
                default:
                    metric = null;
        }
       return metric
    }

    checkUpdate = (props, state, updateAll = false, ) => {
        if(updateAll){
            if( props.selected !== state.selected
                || props.selectedTopics.join(',') !== state.selectedTopics
                || props.selectedSubtopics.join(',') !== state.selectedSubtopics
                || props.startDate !== state.startDate
                || props.endDate !== state.endDate
                || props.grouping !== state.grouping
                || props.first.chartId !== state.firstChart
                || props.first.labels.join(',') !== state.firstLabels
                || props.first.topicIDs !== state.firstTopicIDs
                || props.first.total !== state.firstTotal
                || props.first.fields && Object.values(props.first.fields).join(",") !== state.firstFields
                //|| props.first.max !== state.firstMax
                || props.second.chartId !== state.secondChart
                || props.second.topicIDs !== state.secondTopicIDs
                || props.second.labels.join(',') !== state.secondLabels
                || props.second.total !== state.secondTotal
                //|| props.second.max !== state.secondMax
                || props.third.chartId !== state.thirdChart
                || props.third.topicIDs !== state.thirdTopicIDs
                || props.third.labels.join(',') !== state.thirdLabels
                || props.isChanged
                || props.second.fields && Object.values(props.second.fields).join(",") !== state.secondFields
                || props.third.total !== state.thirdTotal
                //|| props.menuItems[props.selected].charts[0] !== props.first.chartId
                || props.locationsName && Object.values(props.locationsName).join(",") !== state.locationsName
                || props.deviceType !== state.deviceType
                || props.topicFilters.authors !== state.topicsFiltersAuthors//topicsFiltersAuthors: this.props.topicFilters ? this.props.topicFilters.authors : 0,
                || props.topicFilters.domains !== state.topicsFiltersDomains//topicsFiltersAuthors: this.props.topicFilters ? this.props.topicFilters.domains : 0
                || (this.metrics && this.metrics.pageType) && props.first.pageType !== this.metrics.pageType
                || props.selectedLanguage !== state.selectedLanguage
            ){
                    return true
            }
            else return false
        }
        else{
            if( props.selected !== state.selected
                || props.startDate !== state.startDate
                || props.endDate !== state.endDate
                || props.grouping !== state.grouping
                || props.selectedTopics.join(',') !== state.selectedTopics
                || props.selectedSubtopics.join(',') !== state.selectedSubtopics
                || props.isChanged
                || props.first.pageType && props.menuItems[props.selected].title !== props.first.pageType
            ){
                return true
            }
            else return false
        }
    }

    selectedFiltersInPages = (propsSelected, stateSelected, selectedMyFilter) => {
        //if(propsSelected !== stateSelected || (propsSelected === 3 || propsSelected === 7)){
            let filtersSelected = selectedMyFilter;
            if(propsSelected === 3 || propsSelected === 7){
                if(propsSelected === 3){
                    filtersSelected.mediaType = ['SOCIAL']
                    this.props.setMySelectedTopicsFilter(filtersSelected);
                }
                else if(propsSelected === 7){                  
                    filtersSelected.mediaType = ['NEWS_AGENCY', 'TV', 'PRINT', 'INTERNET']
                    this.props.setMySelectedTopicsFilter(filtersSelected);
                }
            }
            else{
                if(stateSelected === 3){
                    this.props.setAddSelectedMyFilter('mediaType', 'SOCIAL', false);
                }
                else if(stateSelected === 7){
                    delete filtersSelected.mediaType;
                    this.props.setMySelectedTopicsFilter(filtersSelected);
                }
            }
        //}
    }

    shouldComponentUpdate(nextProps, nextState){
        /*if(nextProps.selected !== nextState.selected){
            if(nextState.selected === 3){
                nextProps.setAddSelectedMyFilter('mediaType', 'SOCIAL', false);
            }
            else if(nextState.selected === 7){
                let filtersSelected = nextProps.selectedMyFilter;
                delete filtersSelected.mediaType;
                nextProps.setMySelectedTopicsFilter(filtersSelected);
            }
        }*/
        

        if((nextProps.selected == nextState.selected) && nextProps.first.pageType && nextProps.menuItems[nextProps.selected].title !== nextProps.first.pageType){
            
            setTimeout(() => {
                let filters = nextProps.selectedMyFilter;
                filters.clauses = nextProps.searchList
                this.getData(nextProps.selected, nextProps.selectedTopics, nextProps.startDate, nextProps.endDate, nextProps.grouping, filters, nextProps.selectedSubtopics, nextProps.isFetchingAnalytic)
                }, 2000)
        }
        if(nextProps.isFetchingAnalytic && nextProps.first.pageType && (nextProps.menuItems[nextProps.selected].title === nextProps.first.pageType)){
            
            setTimeout(() => {
                this.props.setAnalyticIsFetching(false)
            }, 2500)
            
        }

        if(this.props.leftMenuComponent.findIndex( c => c.componentName === 'settingsMenu') === -1){
            this.props.setLeftMenuComponent(<SettingsMenuContainer items={this.props.menuItems}/>, 'settingsMenu')
        }
        if(nextProps.topics && nextProps.topics.length && (!nextState.topics || nextState.topics == undefined )){
            this.showLeftMenu(nextProps.topics);
            this.showRightMenu(nextProps.selectedTopics)
            this.setState({
                topics: nextProps.topics, 
            })
            return true
        }
        if(nextProps.topics && nextProps.topics.length && nextState.firstStart && !nextProps.selectedTopics.length){ 
           let t = {name: '', id: ''}
            t.name = nextProps.topics[0].name
            t.id = nextProps.topics[0].uuid
            this.props.setSelectedTopicsAll([t])
        }
        if(nextProps.selectedTopics && nextProps.selectedTopics.length && nextProps.selectedTopics.length > 1){
            this.props.setSelectedTopicsAll([nextProps.selectedItems[0]])
        }
        if(!isNaN(this.props.first.total)){
            this.props.setReturnBackPostCount(this.props.first.total) 
        }
        if(this.checkUpdate(nextProps, nextState, true)){
            let filters = nextProps.selectedMyFilter;
            filters.clauses = nextProps.searchList
            this.props.setSelectedFiltersTopics(nextProps.selectedTopics)
            if(nextProps.isChanged)
                this.props.setIsFilterChanged(false)
            if(this.checkUpdate(nextProps, nextState, false) && nextProps.selectedTopics.length){
                this.selectedFiltersInPages(nextProps.selected, nextState.selected, nextProps.selectedMyFilter);
                this.getData(nextProps.selected, nextProps.selectedTopics, nextProps.startDate, nextProps.endDate, nextProps.grouping, filters, nextProps.selectedSubtopics, nextProps.isFetchingAnalytic)
                this.showRightMenu(nextProps.selectedTopics)
            }

            this.metrics = this.getMetrics(nextProps);

            this.setState({
                selected: nextProps.selected,
                selectedTopics: nextProps.selectedTopics.join(','),
                selectedSubtopics: nextProps.selectedSubtopics.join(','),
                firstChart: nextProps.first.chartId,
                firstLabels: nextProps.first.labels.join(","),
                firstTopicIDs: nextProps.first.topicIDs,
                firstFields: nextProps.first.fields ? Object.values(nextProps.first.fields).join(',') : '',
                firstTotal: nextProps.first.total,
                secondChart: nextProps.second.chartId,
                secondTopicIDs: nextProps.second.topicIDs,
                secondLabels: nextProps.second.labels.join(","),
                secondTotal: nextProps.second.total,
                secondFields: nextProps.second.fields ? Object.values(nextProps.second.fields).join(',') : '',
                thirdChart: nextProps.third.chartId,
                thirdTopicIDs: nextProps.third.topicIDs,
                thirdLabels: nextProps.third.labels.join(","),
                thirdTotal: nextProps.third.total,
                startDate: nextProps.startDate,
                endDate: nextProps.endDate,
                grouping: nextProps.grouping,
                locationsName: nextProps.locationsName ? Object.values(nextProps.locationsName).join(",") : "",
                deviceType: nextProps.deviceType,
                topicsFiltersAuthors: nextProps.topicFilters.authors,
                topicsFiltersDomains: nextProps.topicFilters.domains,
                selectedLanguage: this.props.selectedLanguage
                //metric: metrics
                //firstMax: nextProps.first.max,
                //secondMax: nextProps.second.max
            })
            
            return true
        }
        else return false
    }

    componentWillUnmount(){
        //this.props.setSelectedSubtopicsAll(this.props.selectedTopicsItems, []);
        this.props.setRemoveLeftMenuComponent();
        this.props.setRemoveRightMenuComponent();
        this.props.setShowLeftMenu(false);
        this.props.setShowRightMenu(false);
        this.props.setShowPanel(false);
        
        this.props.setAnalyticIsFetching(false);
    }

    render(){
        return <div>
            <Analytic 
                firstMax={this.state.firstMax} 
                secondMax={this.state.secondMax} 
                setMaxData={this.setMaxData} 
                firstData={this.props.first} 
                secondData={this.props.second} 
                thirdData={this.props.third} 
                getValue={this.props.getValue} 
                locationsName={this.props.locationsName} 
                deviceType={this.props.deviceType} 
                metric={this.metrics}
                selectedLanguage={this.props.selectedLanguage}
                setLimit={this.props.setLimit}
                firstLimit={this.props.firstLimit}
            />
        </div>
        
    }
}

export default AnalyticController